import axios from 'axios'

/**
 * Upload a file directly to OSS using a presigned PUT URL.
 * @param {string} uploadUrl - The presigned PUT URL from the backend
 * @param {File} file - The file to upload
 * @param {string} contentType - The content type to send
 * @param {object} options - { onUploadProgress, timeout, signal }
 * @returns {Promise<void>}
 */
export async function ossDirectUpload(uploadUrl, file, contentType, options = {}) {
    await axios.put(uploadUrl, file, {
        headers: {
            'Content-Type': contentType || file.type || 'application/octet-stream',
        },
        timeout: options.timeout || 300000,
        onUploadProgress: typeof options.onUploadProgress === 'function' ? options.onUploadProgress : undefined,
        signal: options.signal,
        withCredentials: false,
    })
}
